var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-content',[_c('v-container',{staticClass:"pa-0",attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('router-view')],1)],1)],1),_c('main-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }